$( document ).ready(function() {

  $("#weglot-language-fr").text("Fr");
  $("#weglot-language-en").text("En");

  // FADE IN/OUT
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function() {
    setTimeout(function(){
    	$("body").removeClass("fade-out");
    }, 250);
  }, false);
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);

  Marquee3k.init({
      selector: 'marquee3k',
  });
  
  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            setTimeout(function(){
              l.src = l.dataset.src;
            }, 500);
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }

  // REMOVE VARIANT FROM MINICART
  $( ".change-title" ).each(function( i ) {
    var getText = $(this).text();
    getText = getText.split('-')[0]
    $(this).text(getText);
  });
  
  // MENU
  $( "#burger" ).click(function() {
    $('#menu-container').toggleClass('show');
    $('header').removeClass('active-in-product-cart');
    $('header').toggleClass('active-in-product');
    $(this).toggleClass('crossed');
    $( "#mini-cart" ).removeClass("active");
    $("#cart-trigger").removeClass("active");
    $("#burger-cart").removeClass("active");
    $("#header-bar").toggleClass("active-home");
  });

  // QTY PRODUCT
  $( ".minus-quan" ).click(function() {
    var getValue = $("#qty").attr("value")
    getValue = parseFloat(getValue) - 1;
    if (getValue > 0) {
      $("#qty").val(getValue);
      $("#qty").attr("value", getValue);
    }
  });
  $( ".plus-quan" ).click(function() {
    var getValue = $("#qty").attr("value")
    getValue = parseFloat(getValue) + 1;
    $("#qty").val(getValue);
    $("#qty").attr("value", getValue);
  });
  
  // TOGGLE MINICART
  $( "#cart-trigger" ).click(function() {
    event.preventDefault();
    $( "#mini-cart" ).toggleClass("active");
    $('header').removeClass('active-in-product');
    $('header').addClass('active-in-product-cart');
    $("#menu-container").removeClass("show");
    $("#burger").removeClass("crossed");
    $("#cart-trigger").addClass("active");
    $("#burger-cart").addClass("active");
    $("#header-bar").addClass("active-home");
  });
  $( "#burger-cart" ).click(function() {
    event.preventDefault();
    $( "#mini-cart" ).removeClass("active");
    $('header').removeClass('active-in-product');
    $('header').removeClass('active-in-product-cart');
    $("#cart-trigger").removeClass("active");
    $("#burger-cart").removeClass("active");
    $("#header-bar").removeClass("active-home");
  });
  $( "#mini-cart-close, #fakexit" ).click(function() {
    $("#fakexit").hide();
    $( "#mini-cart" ).removeClass("active");
  });
  
  // ADD/REMOVE ITEM
  setTimeout(function(){
    $('.cart-product-quantity').each(function() {
      var quantity = $(this).find('input').val(),
          quentityDiv = $(this).find('.quantity-wrap');
      quentityDiv.text(quantity);
      $(this).on('click', '.plus', function(e) {
        incrementValue(e);
      });
      $(this).on('click', '.minus', function(e) {
        decrementValue(e);
      });
    });
  }, 20);
  // ADD PRODUCT
  function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);

    if (!isNaN(currentVal)) {
      parent.find('input[name="updates[]"]').val(currentVal + 1);
    } else {
      parent.find('input[name="updates[]"]').val(0);
    }
  }
  // REMOVE PRODUCT
  function decrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    
    if (!isNaN(currentVal) && currentVal > 0) {
      parent.find('input[name="updates[]"]').val(currentVal - 1);
    } else {
      parent.find('input[name="updates[]"]').val(0);
    }
  }
  // UPDATE CART FUNCTION
  $(document).on('click', '.quantity-button', function(event) {
    event.preventDefault();
    setTimeout(function(){
      $("#update-cart").click();
    }, 10);
  });

  // LEGAL TRIGGERS
  $( ".legal-trigger" ).click(function() {
    var getHash = $(this).attr("data-ide")
    var getTrigger = $(this).attr("data-ide")
    getTrigger = "#" + getTrigger + "-blocks-content"
    var getTitle = $(this).attr("data-ide")
    getTitle = "#" + getTitle + "-title"
    console.log(getTitle)
    $(".legal-block, .legal-title").hide();
    $(getTrigger).show();
    $(getTitle).show();
    $( ".legal-trigger" ).removeClass("active");
    $(this).addClass("active");
    history.replaceState("", document.title, window.location.pathname);
    window.location.hash = getHash;
  });


  // SELECT TO RADIO BUTTON
  $('.product-select-homepage').each(function(i, select){
      var $select = $(select);
      $select.find('option').each(function(j, option){
          var $option = $(option);
          // Create a radio
          var $radio = $('<input type="radio" />');
          // Set name and value:
          $radio.attr('name', $select.attr('name')).attr('value', $option.val()).attr('class', 'variant-input');
          // Set checked if the option was selected
          if ($option.attr('selected')) $radio.attr('checked', 'checked').addClass('checked-variant');
          // Set sold-out class if sold-out class was there
          if ( $($option).is( ".sold-out-variant" ) ) {
            $radio.addClass('sold-out-variant').prop( "disabled", true );
          }
          // Insert radio before select box
          $select.before($radio);
          // Insert a label
          $select.before(
            $("<label />").attr('class', 'variant-input-label').attr('for', $select.attr('name')).text($option.text())
          );
      });
      $select.remove();
  });

  // REMOVE SOLD OUT
  setTimeout(function(){
    $( ".variant-input-label" ).each(function( index ) {
      var text = $(this).text();
      $(this).text(text.replace('-sold-out', ''));         
    });
  }, 300);

  // SELECT SIZE
  setTimeout(function(){
    $( ".variant-input" ).each(function( index ) {
      if ( $(this).is( ".checked-variant" ) ) {
        $(this).next().addClass("selected-size-label");
      }
      if ( $(this).is( ".sold-out-variant" ) ) {
        $(this).next().addClass("sold-out-variant-label-last");
      }
    });
    $( ".variant-input-label" ).click(function() {
      $(this).prev().prop( "checked", true );
      $(this).parent().children( ".variant-input-label" ).removeClass("selected-size-label");
      if( $(this).is(".sold-out-variant-label-last") ){
        $(this).parent().parent().children(".product-add").children(".addtoca").addClass("soldunavailable");
        $(this).parent().parent().children(".product-add").children(".addtoca").val('Sold out');
      } else {
        $(this).parent().parent().children(".product-add").children(".addtoca").removeClass("unavailable").removeClass("soldunavailable");
        $(this).parent().parent().children(".product-add").children(".addtoca").val('Add to cart');
      }
      $(this).addClass("selected-size-label");
    });
  }, 200);

  // SWIPER SECOND SKIN
  const swiper = new Swiper('.swiper-second-skin', {
    direction: 'horizontal',
    loop: true,
    speed: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoHeight: true,
    spaceBetween: 30
  });
  
  const prevArrow = document.querySelector('.prev-arrow');
  const nextArrow = document.querySelector('.next-arrow');
  const colorScroll = document.querySelector('.color-scroll');
  
  if (prevArrow && colorScroll) {
      prevArrow.addEventListener('click', function() {
          colorScroll.scrollBy({
              left: -50, // Scroll 50px to the left
              behavior: 'smooth' // Optional: Add smooth scrolling
          });
      });
  }
  
  if (nextArrow && colorScroll) {
      nextArrow.addEventListener('click', function() {
          colorScroll.scrollBy({
              left: 50, // Scroll 50px to the right
              behavior: 'smooth' // Optional: Add smooth scrolling
          });
      });
  }

  // VIDEO SECOND SKIN
  $('.video-second-skin').click(function(){
      var $this = $(this);
      $this.toggleClass('active');
      if($this.hasClass('active')){
          $this.children("video").get(0).play();
      } else {
          $this.children("video").get(0).pause();
      }
  });
  
});